// extracted by mini-css-extract-plugin
export default {"loading_indicator":"Promo_loading_indicator__0Ahsy","button-loading-spinner":"Promo_button-loading-spinner__TuDTs"};